import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { handleSidenavFullWidth } from "../features/global/globalSlice";
import emblem from "../assets/emblem.png";
import flagDivider from "../assets/flag_divider.svg";
import neaLogo from "../assets/NEA-logo.png";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Avatar, Button, Dropdown, Menu } from "antd";
import kenyaEmblem from "../assets/emblem.png";
import { logout } from "../features/auth/authSlice";

const url = process.env.REACT_APP_API_BASE_URL;

export default function DashboardLayout({ children }) {
  // const { fullWidth } = useSelector((state) => state.global);
  const { user } = useSelector((state) => state.auth);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  async function handleLogout(e) {
    e.preventDefault();
    dispatch(logout());
    await navigate("./login");
  }

  const items = [
    {
      key: "1",
      label: <Link to='/profile'>My Profile</Link>,
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
        >
          <g clipPath='url(#clip0_4865_1210)'>
            {/* <path
              d='M12 6C13.1 6 14 6.9 14 8C14 9.1 13.1 10 12 10C10.9 10 10 9.1 10 8C10 6.9 10.9 6 12 6ZM12 16C14.7 16 17.8 17.29 18 18H6C6.23 17.28 9.31 16 12 16ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z'
              fill='black'
            /> */}
          </g>
          <defs>
            <clipPath id='clip0_4865_1210'>
              <rect width='24' height='24' fill='white' />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      key: "2",
      label: <Link to='/settings'>Account Settings</Link>,
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
        >
          <g clipPath='url(#clip0_4865_9057)'>
            {/* <path
              d='M19.1593 12.98C19.1993 12.66 19.2293 12.34 19.2293 12C19.2293 11.66 19.1993 11.34 19.1593 11.02L21.2693 9.37C21.4593 9.22 21.5093 8.95 21.3893 8.73L19.3893 5.27C19.2993 5.11 19.1293 5.02 18.9493 5.02C18.8893 5.02 18.8293 5.03 18.7793 5.05L16.2893 6.05C15.7693 5.65 15.2093 5.32 14.5993 5.07L14.2193 2.42C14.1893 2.18 13.9793 2 13.7293 2H9.72933C9.47933 2 9.26933 2.18 9.23933 2.42L8.85933 5.07C8.24933 5.32 7.68933 5.66 7.16933 6.05L4.67933 5.05C4.61933 5.03 4.55933 5.02 4.49933 5.02C4.32933 5.02 4.15933 5.11 4.06933 5.27L2.06933 8.73C1.93933 8.95 1.99933 9.22 2.18933 9.37L4.29933 11.02C4.25933 11.34 4.22933 11.67 4.22933 12C4.22933 12.33 4.25933 12.66 4.29933 12.98L2.18933 14.63C1.99933 14.78 1.94933 15.05 2.06933 15.27L4.06933 18.73C4.15933 18.89 4.32933 18.98 4.50933 18.98C4.56933 18.98 4.62933 18.97 4.67933 18.95L7.16933 17.95C7.68933 18.35 8.24933 18.68 8.85933 18.93L9.23933 21.58C9.26933 21.82 9.47933 22 9.72933 22H13.7293C13.9793 22 14.1893 21.82 14.2193 21.58L14.5993 18.93C15.2093 18.68 15.7693 18.34 16.2893 17.95L18.7793 18.95C18.8393 18.97 18.8993 18.98 18.9593 18.98C19.1293 18.98 19.2993 18.89 19.3893 18.73L21.3893 15.27C21.5093 15.05 21.4593 14.78 21.2693 14.63L19.1593 12.98ZM17.1793 11.27C17.2193 11.58 17.2293 11.79 17.2293 12C17.2293 12.21 17.2093 12.43 17.1793 12.73L17.0393 13.86L17.9293 14.56L19.0093 15.4L18.3093 16.61L17.0393 16.1L15.9993 15.68L15.0993 16.36C14.6693 16.68 14.2593 16.92 13.8493 17.09L12.7893 17.52L12.6293 18.65L12.4293 20H11.0293L10.8393 18.65L10.6793 17.52L9.61933 17.09C9.18933 16.91 8.78933 16.68 8.38933 16.38L7.47933 15.68L6.41933 16.11L5.14933 16.62L4.44933 15.41L5.52933 14.57L6.41933 13.87L6.27933 12.74C6.24933 12.43 6.22933 12.2 6.22933 12C6.22933 11.8 6.24933 11.57 6.27933 11.27L6.41933 10.14L5.52933 9.44L4.44933 8.6L5.14933 7.39L6.41933 7.9L7.45933 8.32L8.35933 7.64C8.78933 7.32 9.19933 7.08 9.60933 6.91L10.6693 6.48L10.8293 5.35L11.0293 4H12.4193L12.6093 5.35L12.7693 6.48L13.8293 6.91C14.2593 7.09 14.6593 7.32 15.0593 7.62L15.9693 8.32L17.0293 7.89L18.2993 7.38L18.9993 8.59L17.9293 9.44L17.0393 10.14L17.1793 11.27ZM11.7293 8C9.51933 8 7.72933 9.79 7.72933 12C7.72933 14.21 9.51933 16 11.7293 16C13.9393 16 15.7293 14.21 15.7293 12C15.7293 9.79 13.9393 8 11.7293 8ZM11.7293 14C10.6293 14 9.72933 13.1 9.72933 12C9.72933 10.9 10.6293 10 11.7293 10C12.8293 10 13.7293 10.9 13.7293 12C13.7293 13.1 12.8293 14 11.7293 14Z'
              fill='black'
            /> */}
          </g>
          <defs>
            <clipPath id='clip0_4865_9057'>
              <rect width='24' height='24' fill='white' />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      key: "3",
      label: <Link to='/notification-settings'>Notification Settings</Link>,
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
        >
          <g clipPath='url(#clip0_4865_3241)'>
            {/* <path
              d='M12.0013 22C13.1013 22 14.0013 21.1 14.0013 20H10.0013C10.0013 21.1 10.9012 22 12.0013 22ZM18.0013 16V11C18.0013 7.93 16.3713 5.36 13.5013 4.68V4C13.5013 3.17 12.8313 2.5 12.0013 2.5C11.1713 2.5 10.5013 3.17 10.5013 4V4.68C7.64125 5.36 6.00125 7.92 6.00125 11V16L4.00125 18V19H20.0012V18L18.0013 16ZM16.0013 17H8.00125V11C8.00125 8.52 9.51125 6.5 12.0013 6.5C14.4913 6.5 16.0013 8.52 16.0013 11V17ZM7.58125 4.08L6.15125 2.65C3.75125 4.48 2.17125 7.3 2.03125 10.5H4.03125C4.18125 7.85 5.54125 5.53 7.58125 4.08ZM19.9712 10.5H21.9712C21.8212 7.3 20.2413 4.48 17.8513 2.65L16.4313 4.08C18.4513 5.53 19.8212 7.85 19.9712 10.5Z'
              fill='black'
            /> */}
          </g>
          <defs>
            <clipPath id='clip0_4865_3241'>
              <rect width='24' height='24' fill='white' />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      key: "3",
      label: <Link to='/notification-settings'>Dashboard</Link>,
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
        >
          <g clipPath='url(#clip0_4865_3241)'>
            {/* <path
              d='M12.0013 22C13.1013 22 14.0013 21.1 14.0013 20H10.0013C10.0013 21.1 10.9012 22 12.0013 22ZM18.0013 16V11C18.0013 7.93 16.3713 5.36 13.5013 4.68V4C13.5013 3.17 12.8313 2.5 12.0013 2.5C11.1713 2.5 10.5013 3.17 10.5013 4V4.68C7.64125 5.36 6.00125 7.92 6.00125 11V16L4.00125 18V19H20.0012V18L18.0013 16ZM16.0013 17H8.00125V11C8.00125 8.52 9.51125 6.5 12.0013 6.5C14.4913 6.5 16.0013 8.52 16.0013 11V17ZM7.58125 4.08L6.15125 2.65C3.75125 4.48 2.17125 7.3 2.03125 10.5H4.03125C4.18125 7.85 5.54125 5.53 7.58125 4.08ZM19.9712 10.5H21.9712C21.8212 7.3 20.2413 4.48 17.8513 2.65L16.4313 4.08C18.4513 5.53 19.8212 7.85 19.9712 10.5Z'
              fill='black'
            /> */}
          </g>
          <defs>
            <clipPath id='clip0_4865_3241'>
              <rect width='24' height='24' fill='white' />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      key: "3",
      label: <Link to='/notification-settings'>Application Status</Link>,
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
        >
          <g clipPath='url(#clip0_4865_3241)'>
            {/* <path
              d='M12.0013 22C13.1013 22 14.0013 21.1 14.0013 20H10.0013C10.0013 21.1 10.9012 22 12.0013 22ZM18.0013 16V11C18.0013 7.93 16.3713 5.36 13.5013 4.68V4C13.5013 3.17 12.8313 2.5 12.0013 2.5C11.1713 2.5 10.5013 3.17 10.5013 4V4.68C7.64125 5.36 6.00125 7.92 6.00125 11V16L4.00125 18V19H20.0012V18L18.0013 16ZM16.0013 17H8.00125V11C8.00125 8.52 9.51125 6.5 12.0013 6.5C14.4913 6.5 16.0013 8.52 16.0013 11V17ZM7.58125 4.08L6.15125 2.65C3.75125 4.48 2.17125 7.3 2.03125 10.5H4.03125C4.18125 7.85 5.54125 5.53 7.58125 4.08ZM19.9712 10.5H21.9712C21.8212 7.3 20.2413 4.48 17.8513 2.65L16.4313 4.08C18.4513 5.53 19.8212 7.85 19.9712 10.5Z'
              fill='black'
            /> */}
          </g>
          <defs>
            <clipPath id='clip0_4865_3241'>
              <rect width='24' height='24' fill='white' />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      key: "4",
      label: (
        <Link to='#' onClick={(e) => handleLogout(e)}>
          Logout
        </Link>
      ),
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
        >
          <g clipPath='url(#clip0_4865_3831)'>
            {/* <path
              d='M10.09 15.59L11.5 17L16.5 12L11.5 7L10.09 8.41L12.67 11H3V13H12.67L10.09 15.59ZM19 3H5C3.89 3 3 3.9 3 5V9H5V5H19V19H5V15H3V19C3 20.1 3.89 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z'
              fill='black'
            /> */}
          </g>
          <defs>
            <clipPath id='clip0_4865_3831'>
              <rect width='24' height='24' fill='white' />
            </clipPath>
          </defs>
        </svg>
      ),
    },
  ];

  const menuItems = [
    {
      label: <NavLink to='/dashboard'>Dashboard</NavLink>,
      key: "dashboard",
      icon: (
        <svg
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='grid / 24 / Outline'>
            <path
              id='Vector'
              d='M10.2656 13H3.26562C3.00041 13 2.74605 13.1054 2.55852 13.2929C2.37098 13.4804 2.26563 13.7348 2.26562 14V21C2.26563 21.2652 2.37098 21.5196 2.55852 21.7071C2.74605 21.8946 3.00041 22 3.26562 22H10.2656C10.5308 22 10.7852 21.8946 10.9727 21.7071C11.1603 21.5196 11.2656 21.2652 11.2656 21V14C11.2656 13.7348 11.1603 13.4804 10.9727 13.2929C10.7852 13.1054 10.5308 13 10.2656 13ZM9.26562 20H4.26562V15H9.26562V20ZM21.2656 2H14.2656C14.0004 2 13.7461 2.10536 13.5585 2.29289C13.371 2.48043 13.2656 2.73478 13.2656 3V10C13.2656 10.2652 13.371 10.5196 13.5585 10.7071C13.7461 10.8946 14.0004 11 14.2656 11H21.2656C21.5308 11 21.7852 10.8946 21.9727 10.7071C22.1603 10.5196 22.2656 10.2652 22.2656 10V3C22.2656 2.73478 22.1603 2.48043 21.9727 2.29289C21.7852 2.10536 21.5308 2 21.2656 2ZM20.2656 9H15.2656V4H20.2656V9ZM21.2656 13H14.2656C14.0004 13 13.7461 13.1054 13.5585 13.2929C13.371 13.4804 13.2656 13.7348 13.2656 14V21C13.2656 21.2652 13.371 21.5196 13.5585 21.7071C13.7461 21.8946 14.0004 22 14.2656 22H21.2656C21.5308 22 21.7852 21.8946 21.9727 21.7071C22.1603 21.5196 22.2656 21.2652 22.2656 21V14C22.2656 13.7348 22.1603 13.4804 21.9727 13.2929C21.7852 13.1054 21.5308 13 21.2656 13ZM20.2656 20H15.2656V15H20.2656V20ZM10.2656 2H3.26562C3.00041 2 2.74605 2.10536 2.55852 2.29289C2.37098 2.48043 2.26563 2.73478 2.26562 3V10C2.26563 10.2652 2.37098 10.5196 2.55852 10.7071C2.74605 10.8946 3.00041 11 3.26562 11H10.2656C10.5308 11 10.7852 10.8946 10.9727 10.7071C11.1603 10.5196 11.2656 10.2652 11.2656 10V3C11.2656 2.73478 11.1603 2.48043 10.9727 2.29289C10.7852 2.10536 10.5308 2 10.2656 2ZM9.26562 9H4.26562V4H9.26562V9Z'
              fill='#7792B7'
            />
          </g>
        </svg>
      ),
    },
    {
      label: <NavLink to='/job-vacancies'>Job vacancies</NavLink>,
      key: "job_vacancies",
      icon: (
        <svg
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='search file / 24 / Outline'>
            <path
              id='Vector'
              d='M12.2656 20H5.26562C5.00041 20 4.74605 19.8946 4.55852 19.7071C4.37098 19.5196 4.26562 19.2652 4.26562 19V5C4.26562 4.73478 4.37098 4.48043 4.55852 4.29289C4.74605 4.10536 5.00041 4 5.26562 4H10.2656V7C10.2656 7.79565 10.5817 8.55871 11.1443 9.12132C11.7069 9.68393 12.47 10 13.2656 10H16.2656V11C16.2656 11.2652 16.371 11.5196 16.5585 11.7071C16.7461 11.8946 17.0004 12 17.2656 12C17.5308 12 17.7852 11.8946 17.9727 11.7071C18.1603 11.5196 18.2656 11.2652 18.2656 11V9C18.2656 9 18.2656 9 18.2656 8.94C18.2552 8.84813 18.2351 8.75763 18.2056 8.67V8.58C18.1575 8.47718 18.0934 8.38267 18.0156 8.3L12.0156 2.3C11.933 2.22222 11.8384 2.15808 11.7356 2.11C11.7058 2.10576 11.6755 2.10576 11.6456 2.11C11.544 2.05174 11.4318 2.01434 11.3156 2H5.26562C4.46998 2 3.70691 2.31607 3.1443 2.87868C2.5817 3.44129 2.26563 4.20435 2.26562 5V19C2.26563 19.7956 2.5817 20.5587 3.1443 21.1213C3.70691 21.6839 4.46998 22 5.26562 22H12.2656C12.5308 22 12.7852 21.8946 12.9727 21.7071C13.1603 21.5196 13.2656 21.2652 13.2656 21C13.2656 20.7348 13.1603 20.4804 12.9727 20.2929C12.7852 20.1054 12.5308 20 12.2656 20ZM12.2656 5.41L14.8556 8H13.2656C13.0004 8 12.7461 7.89464 12.5585 7.70711C12.371 7.51957 12.2656 7.26522 12.2656 7V5.41ZM7.26562 8C7.00041 8 6.74605 8.10536 6.55852 8.29289C6.37098 8.48043 6.26562 8.73478 6.26562 9C6.26562 9.26522 6.37098 9.51957 6.55852 9.70711C6.74605 9.89464 7.00041 10 7.26562 10H8.26562C8.53084 10 8.7852 9.89464 8.97273 9.70711C9.16027 9.51957 9.26562 9.26522 9.26562 9C9.26562 8.73478 9.16027 8.48043 8.97273 8.29289C8.7852 8.10536 8.53084 8 8.26562 8H7.26562ZM21.9756 20.29L20.8056 19.13C21.1796 18.4773 21.3293 17.7199 21.2317 16.974C21.1342 16.2281 20.7948 15.5347 20.2656 15C19.7787 14.4957 19.1511 14.1497 18.4647 14.0071C17.7782 13.8646 17.0648 13.9321 16.4173 14.2008C15.7698 14.4695 15.2182 14.927 14.8344 15.5137C14.4506 16.1004 14.2524 16.7891 14.2656 17.49C14.2622 18.0932 14.4165 18.6868 14.7132 19.2119C15.01 19.7371 15.4389 20.1755 15.9574 20.4838C16.4758 20.7921 17.0659 20.9594 17.669 20.9693C18.2721 20.9791 18.8673 20.8311 19.3956 20.54L20.5556 21.71C20.6486 21.8037 20.7592 21.8781 20.881 21.9289C21.0029 21.9797 21.1336 22.0058 21.2656 22.0058C21.3976 22.0058 21.5283 21.9797 21.6502 21.9289C21.7721 21.8781 21.8827 21.8037 21.9756 21.71C22.0694 21.617 22.1437 21.5064 22.1945 21.3846C22.2453 21.2627 22.2714 21.132 22.2714 21C22.2714 20.868 22.2453 20.7373 22.1945 20.6154C22.1437 20.4936 22.0694 20.383 21.9756 20.29ZM18.8056 18.54C18.52 18.8086 18.1427 18.9581 17.7506 18.9581C17.3586 18.9581 16.9812 18.8086 16.6956 18.54C16.4203 18.2598 16.2659 17.8828 16.2656 17.49C16.2636 17.2928 16.3015 17.0971 16.3771 16.915C16.4527 16.7328 16.5645 16.5678 16.7056 16.43C16.9722 16.1648 17.3298 16.0111 17.7056 16C17.9078 15.9876 18.1104 16.0171 18.3006 16.0866C18.4908 16.1562 18.6646 16.2643 18.8111 16.4042C18.9576 16.5441 19.0736 16.7128 19.1518 16.8996C19.23 17.0865 19.2688 17.2875 19.2656 17.49C19.2574 17.8871 19.0919 18.2647 18.8056 18.54ZM13.2656 12H7.26562C7.00041 12 6.74605 12.1054 6.55852 12.2929C6.37098 12.4804 6.26562 12.7348 6.26562 13C6.26562 13.2652 6.37098 13.5196 6.55852 13.7071C6.74605 13.8946 7.00041 14 7.26562 14H13.2656C13.5308 14 13.7852 13.8946 13.9727 13.7071C14.1603 13.5196 14.2656 13.2652 14.2656 13C14.2656 12.7348 14.1603 12.4804 13.9727 12.2929C13.7852 12.1054 13.5308 12 13.2656 12ZM11.2656 18C11.5308 18 11.7852 17.8946 11.9727 17.7071C12.1603 17.5196 12.2656 17.2652 12.2656 17C12.2656 16.7348 12.1603 16.4804 11.9727 16.2929C11.7852 16.1054 11.5308 16 11.2656 16H7.26562C7.00041 16 6.74605 16.1054 6.55852 16.2929C6.37098 16.4804 6.26562 16.7348 6.26562 17C6.26562 17.2652 6.37098 17.5196 6.55852 17.7071C6.74605 17.8946 7.00041 18 7.26562 18H11.2656Z'
              fill=''
            />
          </g>
        </svg>
      ),
    },
    {
      label: <NavLink to='/application-status'>Application status</NavLink>,
      key: "application_status",
      icon: (
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
        >
          <path
            d='M20.1756 15.51H15.6456C15.3804 15.51 15.1261 15.6154 14.9385 15.8029C14.751 15.9904 14.6456 16.2448 14.6456 16.51C14.6456 16.7752 14.751 17.0296 14.9385 17.2171C15.1261 17.4046 15.3804 17.51 15.6456 17.51H18.0456C16.9426 18.6627 15.52 19.4593 13.9608 19.7974C12.4015 20.1355 10.7768 19.9996 9.2954 19.4072C7.81397 18.8149 6.54349 17.7931 5.64722 16.4732C4.75094 15.1532 4.2698 13.5955 4.26562 12C4.26562 11.7348 4.16027 11.4804 3.97273 11.2929C3.7852 11.1054 3.53084 11 3.26562 11C3.00041 11 2.74605 11.1054 2.55852 11.2929C2.37098 11.4804 2.26563 11.7348 2.26562 12C2.27091 13.9528 2.84785 15.8613 3.92523 17.49C5.00261 19.1187 6.53329 20.3964 8.32837 21.1652C10.1234 21.9341 12.1044 22.1605 14.0266 21.8166C15.9489 21.4727 17.7285 20.5735 19.1456 19.23V21C19.1456 21.2652 19.251 21.5196 19.4385 21.7071C19.6261 21.8946 19.8804 22 20.1456 22C20.4108 22 20.6652 21.8946 20.8527 21.7071C21.0403 21.5196 21.1456 21.2652 21.1456 21V16.5C21.1432 16.2416 21.0408 15.9943 20.86 15.8097C20.6791 15.6251 20.4339 15.5177 20.1756 15.51ZM15.2656 12C15.2656 11.4067 15.0897 10.8266 14.76 10.3333C14.4304 9.83994 13.9619 9.45542 13.4137 9.22836C12.8655 9.0013 12.2623 8.94189 11.6804 9.05764C11.0984 9.1734 10.5639 9.45912 10.1443 9.87868C9.72475 10.2982 9.43902 10.8328 9.32327 11.4147C9.20751 11.9967 9.26692 12.5999 9.49399 13.1481C9.72105 13.6962 10.1056 14.1648 10.5989 14.4944C11.0923 14.8241 11.6723 15 12.2656 15C13.0613 15 13.8243 14.6839 14.3869 14.1213C14.9496 13.5587 15.2656 12.7956 15.2656 12ZM11.2656 12C11.2656 11.8022 11.3243 11.6089 11.4342 11.4444C11.544 11.28 11.7002 11.1518 11.8829 11.0761C12.0657 11.0004 12.2667 10.9806 12.4607 11.0192C12.6547 11.0578 12.8329 11.153 12.9727 11.2929C13.1126 11.4327 13.2078 11.6109 13.2464 11.8049C13.285 11.9989 13.2652 12.2 13.1895 12.3827C13.1138 12.5654 12.9856 12.7216 12.8212 12.8315C12.6567 12.9414 12.4634 13 12.2656 13C12.0004 13 11.7461 12.8946 11.5585 12.7071C11.371 12.5196 11.2656 12.2652 11.2656 12ZM12.2656 2C9.70201 2.00731 7.23912 2.99891 5.38562 4.77V3C5.38562 2.73478 5.28027 2.48043 5.09273 2.29289C4.9052 2.10536 4.65084 2 4.38562 2C4.12041 2 3.86605 2.10536 3.67852 2.29289C3.49098 2.48043 3.38562 2.73478 3.38562 3V7.5C3.38562 7.76522 3.49098 8.01957 3.67852 8.20711C3.86605 8.39464 4.12041 8.5 4.38562 8.5H8.88562C9.15084 8.5 9.4052 8.39464 9.59273 8.20711C9.78027 8.01957 9.88562 7.76522 9.88562 7.5C9.88562 7.23478 9.78027 6.98043 9.59273 6.79289C9.4052 6.60536 9.15084 6.5 8.88562 6.5H6.48562C7.58809 5.34787 9.00972 4.5515 10.568 4.21311C12.1263 3.87472 13.7502 4.00975 15.2312 4.60086C16.7122 5.19198 17.9828 6.21221 18.8799 7.5306C19.7769 8.849 20.2595 10.4054 20.2656 12C20.2656 12.2652 20.371 12.5196 20.5585 12.7071C20.7461 12.8946 21.0004 13 21.2656 13C21.5308 13 21.7852 12.8946 21.9727 12.7071C22.1603 12.5196 22.2656 12.2652 22.2656 12C22.2656 10.6868 22.007 9.38642 21.5044 8.17317C21.0019 6.95991 20.2653 5.85752 19.3367 4.92893C18.4081 4.00035 17.3057 3.26375 16.0925 2.7612C14.8792 2.25866 13.5788 2 12.2656 2Z'
            fill=''
          />
        </svg>
      ),
    },
    // {
    // 	label: <NavLink to='/skills'>Skills</NavLink>,
    // 	key: 'skills',
    // 	icon: (
    // 		<svg
    // 			width='25'
    // 			height='24'
    // 			viewBox='0 0 25 24'
    // 			fill='none'
    // 			xmlns='http://www.w3.org/2000/svg'
    // 		>
    // 			<g id='star shape / 24 / Outline'>
    // 				<path
    // 					id='Vector'
    // 					d='M22.2671 9.67161C22.2039 9.4887 22.089 9.32804 21.9364 9.20911C21.7837 9.09019 21.5999 9.01811 21.4071 9.00161L15.7171 8.17161L13.1671 3.00161C13.0852 2.83254 12.9573 2.68995 12.7982 2.59018C12.639 2.49041 12.4549 2.4375 12.2671 2.4375C12.0792 2.4375 11.8952 2.49041 11.736 2.59018C11.5768 2.68995 11.449 2.83254 11.3671 3.00161L8.81707 8.16161L3.12707 9.00161C2.94199 9.02792 2.76799 9.10557 2.62482 9.22577C2.48164 9.34596 2.37503 9.50388 2.31707 9.68161C2.26401 9.85528 2.25925 10.0401 2.3033 10.2163C2.34734 10.3925 2.43852 10.5533 2.56707 10.6816L6.69707 14.6816L5.69707 20.3616C5.66137 20.5491 5.68006 20.7429 5.75094 20.9201C5.82182 21.0973 5.94192 21.2505 6.09707 21.3616C6.24828 21.4697 6.42664 21.5335 6.61211 21.5459C6.79759 21.5583 6.98284 21.5187 7.14707 21.4316L12.2671 18.7616L17.3671 21.4416C17.5074 21.5208 17.6659 21.5621 17.8271 21.5616C18.0389 21.5624 18.2455 21.4958 18.4171 21.3716C18.5722 21.2605 18.6923 21.1073 18.7632 20.9301C18.8341 20.7529 18.8528 20.5591 18.8171 20.3716L17.8171 14.6916L21.9471 10.6916C22.0914 10.5693 22.1982 10.4085 22.2548 10.228C22.3114 10.0474 22.3157 9.85448 22.2671 9.67161ZM16.1171 13.6716C15.9998 13.785 15.9121 13.9255 15.8615 14.0806C15.811 14.2357 15.7991 14.4009 15.8271 14.5616L16.5471 18.7516L12.7871 16.7516C12.6424 16.6746 12.481 16.6343 12.3171 16.6343C12.1532 16.6343 11.9917 16.6746 11.8471 16.7516L8.08707 18.7516L8.80707 14.5616C8.835 14.4009 8.82318 14.2357 8.77263 14.0806C8.72208 13.9255 8.63434 13.785 8.51707 13.6716L5.51707 10.6716L9.72707 10.0616C9.88907 10.0391 10.0431 9.97715 10.1756 9.88126C10.3081 9.78537 10.415 9.65845 10.4871 9.51161L12.2671 5.70161L14.1471 9.52161C14.2191 9.66845 14.3261 9.79537 14.4586 9.89126C14.5911 9.98715 14.7451 10.0491 14.9071 10.0716L19.1171 10.6816L16.1171 13.6716Z'
    // 					fill=''
    // 				/>
    // 			</g>
    // 		</svg>
    // 	),
    // },
    // {
    //   label: <NavLink to='/find-counselor'>Find a Counselor</NavLink>,
    //   key: "find_counselor",
    //   icon: (
    //     <svg
    //       width='25'
    //       height='24'
    //       viewBox='0 0 25 24'
    //       fill='none'
    //       xmlns='http://www.w3.org/2000/svg'
    //     >
    //       <g id='heart / 24 / Outline'>
    //         <path
    //           id='Vector'
    //           d='M20.4259 4.99626C19.3659 3.93347 17.9607 3.2848 16.4642 3.16743C14.9678 3.05006 13.4787 3.47173 12.2659 4.35626C10.9936 3.4099 9.40989 2.98077 7.83382 3.1553C6.25775 3.32982 4.80634 4.09504 3.77187 5.29684C2.73741 6.49865 2.19672 8.04778 2.2587 9.63227C2.32068 11.2168 2.98072 12.7189 4.1059 13.8363L10.3159 20.0563C10.8359 20.568 11.5363 20.8549 12.2659 20.8549C12.9955 20.8549 13.6959 20.568 14.2159 20.0563L20.4259 13.8363C21.5935 12.6615 22.2488 11.0725 22.2488 9.41626C22.2488 7.75999 21.5935 6.17099 20.4259 4.99626ZM19.0159 12.4563L12.8059 18.6663C12.7352 18.7376 12.6511 18.7943 12.5584 18.8329C12.4658 18.8716 12.3663 18.8915 12.2659 18.8915C12.1655 18.8915 12.066 18.8716 11.9734 18.8329C11.8807 18.7943 11.7966 18.7376 11.7259 18.6663L5.5159 12.4263C4.73166 11.6246 4.29251 10.5477 4.29251 9.42626C4.29251 8.30479 4.73166 7.22791 5.5159 6.42626C6.31506 5.63725 7.39287 5.19483 8.5159 5.19483C9.63893 5.19483 10.7167 5.63725 11.5159 6.42626C11.6089 6.51999 11.7195 6.59438 11.8413 6.64515C11.9632 6.69592 12.0939 6.72206 12.2259 6.72206C12.3579 6.72206 12.4886 6.69592 12.6105 6.64515C12.7323 6.59438 12.8429 6.51999 12.9359 6.42626C13.7351 5.63725 14.8129 5.19483 15.9359 5.19483C17.0589 5.19483 18.1367 5.63725 18.9359 6.42626C19.7309 7.21741 20.1845 8.28845 20.1994 9.40995C20.2144 10.5314 19.7895 11.6142 19.0159 12.4263V12.4563Z'
    //           fill=''
    //         />
    //       </g>
    //     </svg>
    //   ),
    // },
    // {
    //   label: (
    //     <NavLink to='/foreign-job-clearance'>Foreign Job Clearance</NavLink>
    //   ),
    //   key: "foreign-job-clearance",
    //   icon: (
    //     <svg
    //       xmlns='http://www.w3.org/2000/svg'
    //       width='25'
    //       height='24'
    //       viewBox='0 0 25 24'
    //       fill='none'
    //     >
    //       <path
    //         d='M22.0157 11.9987C22.0151 11.8141 21.9634 11.6332 21.8663 11.4761C21.7693 11.319 21.6306 11.1918 21.4657 11.1087L15.3457 8.04875V4.04875C15.3457 3.23188 15.0212 2.44847 14.4435 1.87086C13.8659 1.29325 13.0825 0.96875 12.2657 0.96875C11.4488 0.96875 10.6654 1.29325 10.0878 1.87086C9.51016 2.44847 9.18566 3.23188 9.18566 4.04875V8.04875L3.06566 11.1087C2.90075 11.1918 2.76206 11.319 2.66498 11.4761C2.5679 11.6332 2.51622 11.8141 2.51566 11.9987V15.3287C2.5143 15.4917 2.55277 15.6524 2.62771 15.7971C2.70265 15.9417 2.8118 16.0659 2.94566 16.1587C3.07876 16.2499 3.23195 16.3076 3.39215 16.3267C3.55235 16.3459 3.71481 16.326 3.86566 16.2688L9.18566 14.2688V17.9988L7.36566 18.5988C7.16704 18.6658 6.99452 18.7936 6.8725 18.9641C6.75048 19.1346 6.68512 19.3391 6.68566 19.5487V21.9988C6.68621 22.1311 6.71301 22.2619 6.7645 22.3838C6.816 22.5057 6.89117 22.6161 6.98566 22.7087C7.17192 22.8935 7.42332 22.9976 7.68566 22.9988H16.8557C17.1209 22.9988 17.3752 22.8934 17.5628 22.7059C17.7503 22.5183 17.8557 22.264 17.8557 21.9988V19.4988C17.8562 19.2891 17.7908 19.0846 17.6688 18.9141C17.5468 18.7436 17.3743 18.6158 17.1757 18.5487L15.3457 17.9988V14.2787L20.6657 16.2788C20.8165 16.336 20.979 16.3559 21.1392 16.3367C21.2994 16.3176 21.4526 16.2599 21.5857 16.1687C21.7195 16.0759 21.8287 15.9517 21.9036 15.8071C21.9786 15.6624 22.017 15.5017 22.0157 15.3387V11.9987ZM14.7057 11.8987C14.5534 11.8398 14.3891 11.819 14.227 11.8382C14.0649 11.8573 13.9099 11.9159 13.7757 12.0087C13.6432 12.1006 13.5349 12.2232 13.46 12.366C13.3852 12.5088 13.3459 12.6675 13.3457 12.8287V18.6688C13.3458 18.8796 13.4126 19.0851 13.5366 19.2557C13.6605 19.4263 13.8352 19.5534 14.0357 19.6188L15.8457 20.2188V20.9988H8.67566V20.2188L10.4857 19.6188C10.6861 19.5534 10.8608 19.4263 10.9848 19.2557C11.1087 19.0851 11.1755 18.8796 11.1757 18.6688V12.8287C11.1754 12.6675 11.1362 12.5088 11.0613 12.366C10.9864 12.2232 10.8781 12.1006 10.7457 12.0087C10.6114 11.9159 10.4564 11.8573 10.2943 11.8382C10.1322 11.819 9.96788 11.8398 9.81566 11.8987L4.50566 13.8987V12.6187L10.6157 9.55875C10.7824 9.47704 10.9232 9.35049 11.0221 9.1933C11.121 9.0361 11.1742 8.85447 11.1757 8.66875V4.07875C11.1757 3.79232 11.2894 3.51761 11.492 3.31507C11.6945 3.11254 11.9692 2.99875 12.2557 2.99875C12.5421 2.99875 12.8168 3.11254 13.0193 3.31507C13.2219 3.51761 13.3357 3.79232 13.3357 4.07875V8.66875C13.3371 8.85447 13.3903 9.0361 13.4892 9.1933C13.5881 9.35049 13.7289 9.47704 13.8957 9.55875L20.0057 12.6187V13.8888L14.7057 11.8987Z'
    //         fill=''
    //       />
    //     </svg>
    //   ),
    // },
    // {
    //   label: <NavLink to='/cv-cover-letter'>CV/Cover Letter</NavLink>,
    //   key: "Cv_cover_letter",
    //   icon: (
    //     <svg
    //       width='25'
    //       height='24'
    //       viewBox='0 0 25 24'
    //       fill='none'
    //       xmlns='http://www.w3.org/2000/svg'
    //     >
    //       <g id='Newspaper / 24 / Outline'>
    //         <path
    //           id='Vector'
    //           d='M17.2656 11H16.2656C16.0004 11 15.7461 11.1054 15.5585 11.2929C15.371 11.4804 15.2656 11.7348 15.2656 12C15.2656 12.2652 15.371 12.5196 15.5585 12.7071C15.7461 12.8946 16.0004 13 16.2656 13H17.2656C17.5308 13 17.7852 12.8946 17.9727 12.7071C18.1603 12.5196 18.2656 12.2652 18.2656 12C18.2656 11.7348 18.1603 11.4804 17.9727 11.2929C17.7852 11.1054 17.5308 11 17.2656 11ZM17.2656 15H16.2656C16.0004 15 15.7461 15.1054 15.5585 15.2929C15.371 15.4804 15.2656 15.7348 15.2656 16C15.2656 16.2652 15.371 16.5196 15.5585 16.7071C15.7461 16.8946 16.0004 17 16.2656 17H17.2656C17.5308 17 17.7852 16.8946 17.9727 16.7071C18.1603 16.5196 18.2656 16.2652 18.2656 16C18.2656 15.7348 18.1603 15.4804 17.9727 15.2929C17.7852 15.1054 17.5308 15 17.2656 15ZM11.2656 9H17.2656C17.5308 9 17.7852 8.89464 17.9727 8.70711C18.1603 8.51957 18.2656 8.26522 18.2656 8C18.2656 7.73478 18.1603 7.48043 17.9727 7.29289C17.7852 7.10536 17.5308 7 17.2656 7H11.2656C11.0004 7 10.7461 7.10536 10.5585 7.29289C10.371 7.48043 10.2656 7.73478 10.2656 8C10.2656 8.26522 10.371 8.51957 10.5585 8.70711C10.7461 8.89464 11.0004 9 11.2656 9ZM21.2656 3H7.26562C7.00041 3 6.74605 3.10536 6.55852 3.29289C6.37098 3.48043 6.26562 3.73478 6.26562 4V7H3.26562C3.00041 7 2.74605 7.10536 2.55852 7.29289C2.37098 7.48043 2.26563 7.73478 2.26562 8V18C2.26563 18.7956 2.5817 19.5587 3.1443 20.1213C3.70691 20.6839 4.46998 21 5.26562 21H18.2656C19.3265 21 20.3439 20.5786 21.0941 19.8284C21.8442 19.0783 22.2656 18.0609 22.2656 17V4C22.2656 3.73478 22.1603 3.48043 21.9727 3.29289C21.7852 3.10536 21.5308 3 21.2656 3ZM6.26562 18C6.26562 18.2652 6.16027 18.5196 5.97273 18.7071C5.7852 18.8946 5.53084 19 5.26562 19C5.00041 19 4.74605 18.8946 4.55852 18.7071C4.37098 18.5196 4.26562 18.2652 4.26562 18V9H6.26562V18ZM20.2656 17C20.2656 17.5304 20.0549 18.0391 19.6798 18.4142C19.3048 18.7893 18.7961 19 18.2656 19H8.08563C8.20205 18.6793 8.26292 18.3411 8.26562 18V5H20.2656V17ZM11.2656 13H12.2656C12.5308 13 12.7852 12.8946 12.9727 12.7071C13.1603 12.5196 13.2656 12.2652 13.2656 12C13.2656 11.7348 13.1603 11.4804 12.9727 11.2929C12.7852 11.1054 12.5308 11 12.2656 11H11.2656C11.0004 11 10.7461 11.1054 10.5585 11.2929C10.371 11.4804 10.2656 11.7348 10.2656 12C10.2656 12.2652 10.371 12.5196 10.5585 12.7071C10.7461 12.8946 11.0004 13 11.2656 13ZM11.2656 17H12.2656C12.5308 17 12.7852 16.8946 12.9727 16.7071C13.1603 16.5196 13.2656 16.2652 13.2656 16C13.2656 15.7348 13.1603 15.4804 12.9727 15.2929C12.7852 15.1054 12.5308 15 12.2656 15H11.2656C11.0004 15 10.7461 15.1054 10.5585 15.2929C10.371 15.4804 10.2656 15.7348 10.2656 16C10.2656 16.2652 10.371 16.5196 10.5585 16.7071C10.7461 16.8946 11.0004 17 11.2656 17Z'
    //           fill=''
    //         />
    //       </g>
    //     </svg>
    //   ),
    // },
    {
      label: <NavLink to='/profile'>Profile</NavLink>,
      key: "profile",
      icon: (
        <svg
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g id='account / 24 / Outline'>
            <path
              id='Vector'
              d='M15.0756 12.28C15.7086 11.6002 16.0652 10.7088 16.0756 9.78C16.0756 8.77748 15.6774 7.81602 14.9685 7.10714C14.2596 6.39825 13.2981 6 12.2956 6C11.2931 6 10.3316 6.39825 9.62276 7.10714C8.91387 7.81602 8.51562 8.77748 8.51562 9.78C8.52606 10.7088 8.88265 11.6002 9.51562 12.28C8.63428 12.7189 7.87585 13.3699 7.30854 14.1746C6.74124 14.9793 6.38285 15.9124 6.26562 16.89C6.23645 17.1552 6.31383 17.4212 6.48074 17.6293C6.64764 17.8375 6.89041 17.9708 7.15562 18C7.42084 18.0292 7.68678 17.9518 7.89495 17.7849C8.10312 17.618 8.23645 17.3752 8.26562 17.11C8.38496 16.1411 8.85447 15.2494 9.58571 14.6027C10.317 13.956 11.2594 13.599 12.2356 13.599C13.2118 13.599 14.1543 13.956 14.8855 14.6027C15.6168 15.2494 16.0863 16.1411 16.2056 17.11C16.2334 17.3664 16.3592 17.6022 16.5568 17.768C16.7543 17.9339 17.0083 18.017 17.2656 18H17.3756C17.6378 17.9698 17.8774 17.8373 18.0422 17.6313C18.207 17.4252 18.2837 17.1624 18.2556 16.9C18.1471 15.9276 17.8 14.997 17.2452 14.191C16.6905 13.3851 15.9452 12.7286 15.0756 12.28ZM12.2656 11.56C11.9136 11.56 11.5694 11.4556 11.2767 11.26C10.984 11.0644 10.7558 10.7864 10.6211 10.4612C10.4864 10.1359 10.4511 9.77803 10.5198 9.43274C10.5885 9.08745 10.758 8.77029 11.007 8.52135C11.2559 8.27241 11.5731 8.10288 11.9184 8.0342C12.2637 7.96552 12.6215 8.00077 12.9468 8.13549C13.2721 8.27022 13.5501 8.49837 13.7456 8.79109C13.9412 9.0838 14.0456 9.42795 14.0456 9.78C14.0456 10.2521 13.8581 10.7048 13.5243 11.0387C13.1905 11.3725 12.7377 11.56 12.2656 11.56ZM19.2656 2H5.26562C4.46998 2 3.70691 2.31607 3.1443 2.87868C2.5817 3.44129 2.26563 4.20435 2.26562 5V19C2.26563 19.7956 2.5817 20.5587 3.1443 21.1213C3.70691 21.6839 4.46998 22 5.26562 22H19.2656C20.0613 22 20.8243 21.6839 21.3869 21.1213C21.9496 20.5587 22.2656 19.7956 22.2656 19V5C22.2656 4.20435 21.9496 3.44129 21.3869 2.87868C20.8243 2.31607 20.0613 2 19.2656 2ZM20.2656 19C20.2656 19.2652 20.1603 19.5196 19.9727 19.7071C19.7852 19.8946 19.5308 20 19.2656 20H5.26562C5.00041 20 4.74605 19.8946 4.55852 19.7071C4.37098 19.5196 4.26562 19.2652 4.26562 19V5C4.26562 4.73478 4.37098 4.48043 4.55852 4.29289C4.74605 4.10536 5.00041 4 5.26562 4H19.2656C19.5308 4 19.7852 4.10536 19.9727 4.29289C20.1603 4.48043 20.2656 4.73478 20.2656 5V19Z'
              fill='#7792B7'
            />
          </g>
        </svg>
      ),
    },
  ];

  useEffect(() => {}, []);

  const fullWidth = true;

  // useEffect(() => {}, [fullWidth]);

  return (
    <>
      <div className='w-full max-h-full h-[107px]'>
        <div
          style={{
            boxShadow:
              "0px 1px 10px 0px rgba(0, 0, 0, 0.12), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.20)",
          }}
          className='w-full h-[80px] bg-white flex items-center justify-between'
        >
          <div className='flex items-center'>
            <img
              src={emblem}
              className='ml-[10px] mr-[5px] object-contain w-[97px] h-[67px]'
              alt='kenya Emplem'
            />
            <img
              className='h-10 w-auto'
              src={flagDivider}
              alt='kenya flag colors'
            />
            <img
              src={neaLogo}
              className='ml-[10px] object-contain w-[166px] h-[50px]'
              alt='NEAIMIS Logo'
            />
          </div>

          <div className='flex items-center'>
            <button
              onClick={() => navigate("/")}
              type='button'
              className='bg-transparent nav-items mr-[54px]'
            >
              Home
            </button>
            <button
              onClick={() => navigate("/job-vacancies")}
              type='button'
              className='bg-transparent nav-items mr-[54px]'
            >
              Find Job
            </button>
            <button
              onClick={() => navigate("/application-status")}
              type='button'
              className='bg-transparent nav-items mr-[54px]'
            >
              Job Alerts
            </button>
          </div>
          <div className='mr-[20px] rounded-full border border-darkBlue'>
            <Dropdown
              overlayStyle={{
                width: "250px",
              }}
              menu={{
                items,
              }}
              placement='bottomLeft'
            >
              <img
                className='w-[50px] h-[50px] object-cover rounded-full'
                src={
                  "https://kazi254.ke/myimages/OTP_IMAGES/ACCOUNT_OPENING/avatar.png"
                }
                alt='user-profile'
              />
            </Dropdown>
          </div>
        </div>

        <div className='flex'>
          <div
            className={
              fullWidth
                ? "hidden md:flex flex-col w-[24%] mt-7 ml-3 h-[80vh]  max-h-[100vh] bg-white p-3 cv-scroll overflow-y-scroll"
                : "max-h-full h-[100vh]"
            }
          >
            <div
              style={
                {
                  // display: fullWidth ? 'block' : 'none',
                }
              }
              className=' w-full max-w-sm bg-mainBg rounded-lg'
            >
              {fullWidth && (
                <div class='card'>
                  <div class='cover-photo'>
                    <img
                      style={{
                        zIndex: "1000",
                      }}
                      src={
                        "https://kazi254.ke/myimages/OTP_IMAGES/ACCOUNT_OPENING/avatar.png"
                      }
                      alt='profile'
                      class='profile z-40 rounded'
                    />
                  </div>
                  <div className='flex flex-col items-center'>
                    <span className='profile-name mt-[19%]'>
                      {user?.usrFullNames}
                    </span>
                    <span className='profile-email mt-2'>{user?.usrEmail}</span>
                    <span className='profile-no mt-2'>
                      +{user?.usrMobileNumber}
                    </span>
                    <span className='profile-status p-1 mt-2'>
                      Status: valid
                    </span>
                    <div className='mt-3 mb-5'>
                      <Link to='/profile' className='profile-link'>
                        My Profile
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className='hidden md:flex mt-4'>
              <Menu
                style={{
                  height: !fullWidth ? "100vh" : "auto",
                  paddingTop: !fullWidth ? "20px" : "5px",
                }}
                defaultSelectedKeys={["1"]}
                defaultOpenKeys={["sub1"]}
                mode='inline'
                theme='light'
                inlineCollapsed={!fullWidth}
                items={menuItems}
              />
            </div>
          </div>
          <div className='w-full p-1 max-h-full h-[85vh] overflow-x-hidden overflow-y-auto mt-6'>
            {children}
          </div>
        </div>
      </div>
    </>
  );
}
